export default __webpack_public_path__ + "media/119703cb67bd72425e1b045e9a959d93.png";